// src/components/Sidebar/Sidebar.jsx
import React, { useState } from 'react';
import './Sidebar.css';
import logoutIcon from '../../icons/Vector.png';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = ({ onLogout, isOpen, closeSidebar }) => {
  const [mapsOpen, setMapsOpen] = useState(true);
  const [guidesOpen, setGuidesOpen] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const isEditingPage = () => {
    const p = location.pathname;
    return (
      p.endsWith('/edit') ||
      p.startsWith('/edit-db-series') ||
      p.startsWith('/edit-collector') ||
      p.startsWith('/edit-house')
    );
  };

  const handleNavClick = (pathOrFunc) => {
    if (isEditingPage()) {
      window.dispatchEvent(
        new CustomEvent('navigateAttempt', { detail: pathOrFunc })
      );
    } else {
      typeof pathOrFunc === 'function'
        ? pathOrFunc()
        : navigate(pathOrFunc);
    }
    if (isOpen) closeSidebar();
  };

  return (
    <div
      className={`sidebar${isOpen ? ' open' : ''}`}
      onClick={() => {
        if (closeSidebar) closeSidebar();
      }}
    >
      {/* ---- Шапка пользователя ---- */}
      <div className="sidebar-user">
        <div className="sidebar-user-info">
          <div className="sidebar-user-name">Лахмостова Ю. А.</div>
          <div className="sidebar-user-role">Пользователь</div>
        </div>
        <button className="sidebar-logout-button" onClick={() => handleNavClick(onLogout)}>
          <img src={logoutIcon} alt="Выход" className="logout-icon" />
        </button>
      </div>

      {/* ---- Навигация ---- */}
      <div className="sidebar-content">
        <nav>
          <ul>
            {/* Карты */}
            <li>
              <button className="dropdown-toggle" onClick={() => setMapsOpen(!mapsOpen)}>
                Карты
                <span className={`arrow ${mapsOpen ? 'open' : ''}`}>⌄</span>
              </button>
              <ul className={`submenu ${mapsOpen ? 'show' : ''}`}>
                <li
                  className={location.pathname === '/collectors' ? 'active' : ''}
                  onClick={() => handleNavClick('/collectors')}
                >
                  Карта коллекторов
                </li>
                <li
                  className={location.pathname === '/expenses' ? 'active' : ''}
                  onClick={() => handleNavClick('/expenses')}
                >
                  Карта домов
                </li>
                <li
                  className={location.pathname === '/pipeline' ? 'active' : ''}
                  onClick={() => handleNavClick('/pipeline')}
                >
                  Карта приоритетов
                </li>
              </ul>
            </li>

            {/* Справочники */}
            <li>
              <button className="dropdown-toggle" onClick={() => setGuidesOpen(!guidesOpen)}>
                Справочники
                <span className={`arrow ${guidesOpen ? 'open' : ''}`}>⌄</span>
              </button>
              <ul className={`submenu ${guidesOpen ? 'show' : ''}`}>
                <li
                  className={location.pathname === '/db-house' ? 'active' : ''}
                  onClick={() => handleNavClick('/db-house')}
                >
                  БД домов
                </li>
                <li
                  className={location.pathname === '/db-collectors' ? 'active' : ''}
                  onClick={() => handleNavClick('/db-collectors')}
                >
                  БД коллекторов
                </li>
                <li
                  className={location.pathname === '/db-series' ? 'active' : ''}
                  onClick={() => handleNavClick('/db-series')}
                >
                  БД серий домов
                </li>
              </ul>
            </li>

            {/* Журнал поломок */}
            <li>
              <button
                className={location.pathname === '/check' ? 'active' : ''}
                onClick={() => handleNavClick('/check')}
              >
                Журнал поломок
              </button>
            </li>

            {/* Сводный анализ */}
            <li>
              <button
                className={location.pathname === '/summary-reports' ? 'active' : ''}
                onClick={() => handleNavClick('/summary-reports')}
              >
                Сводный анализ
              </button>
            </li>

            {/* Руководство */}
            <li>
              <button
                className={location.pathname === '/guide' ? 'active' : ''}
                onClick={() => handleNavClick('/guide')}
              >
                Руководство пользователя
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
